<script setup lang="ts">
import LoyaltyCreateContainer from './LoyaltyCreateContainer.vue'
import LoyaltyCreateGradientCard from './LoyaltyCreateGradientCard.vue'

const { handleLoyaltyClick } = useLoyalty()
const { getStoreSchedulingPlatformUrl } = useStore()
const { openInNewTab } = useDOM()
const { t } = useI18n()

const external = `${getStoreSchedulingPlatformUrl()}?utm_source=pongo&utm_medium=dashboard&utm_campaign=je-veux-faire-pareil&utm_content=loyalty`
const redirectToScheduling = () => openInNewTab(external)
const secondImage = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/loyalty/fid_tablette_c.png`)
const firstImage = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/b2c/webapp/slider/crm.png`)
</script>

<template>
  <LoyaltyCreateContainer>
    <h1 class="mb-8 text-lg font-semibold">{{ t('pages.loyalty.create.instructions.softNotFoundAsk') }}</h1>
    <div class="flex flex-col items-center justify-center gap-10 px-10 md:flex-row">
      <LoyaltyCreateGradientCard
        :title="t('pages.loyalty.create.getInTouch')"
        :image="firstImage"
        @click="() => redirectToScheduling()"
      >
        {{ t('pages.loyalty.create.getInTouchDescription') }}
      </LoyaltyCreateGradientCard>
      <LoyaltyCreateGradientCard
        :title="t('pages.loyalty.create.selectTablet')"
        :image="secondImage"
        @click="() => handleLoyaltyClick()"
      >
        {{ t('pages.loyalty.create.tabletDescription') }}
      </LoyaltyCreateGradientCard>
    </div>
  </LoyaltyCreateContainer>
</template>
